import { Dialog } from "components/Dialog";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import ApartmentsGrid from "components/Grid/grids/ApartmentsGrid";
import { useURLTools } from "utils/URLtools";
import { DataGridRef } from "devextreme-react/data-grid";
import { TApartmentGridRow } from "components/Grid/grids/ApartmentsGrid/types";

type TProps = {
  isOpen?: boolean;
  onClose: () => void;
  onSelectApartment: (value: TApartmentGridRow) => void;
};

export type TAddFormTypes = {
  apartmentId: string;
  floorNo: number;
  unitNo: string;
  identifierId: string;
  subscriberName: string;
  nationalId: string;
  phoneNumber: string;
  mobileNumber: string;
  postalCode: string;
  email: string;
  waterMeterId: string;
  installationDT: Date;
};

export function ApartmentsChooserModal(props: TProps) {
  const { isOpen = false, onClose, onSelectApartment } = props;

  const { t } = useTranslation();

  const { queryParams } = useURLTools();
  const GridRef = useRef<DataGridRef<any, any>>(null);

  const onApartmentsGridRowClick = (value: TApartmentGridRow) => {
    onSelectApartment(value);
  };

  return (
    <Dialog
      maxWidth={false}
      dialogTitle={t("chooseApartment")}
      open={isOpen}
      onClose={onClose}
    >
      <p className={"text-gray-110 mr-3 text-sm my-1"}>
        {t("chooseApartmentFromList")}
      </p>
      <div className={"w-[1080px] h-[640px] px-2"}>
        <ApartmentsGrid
          provinceId={queryParams?.provinceId}
          cityId={queryParams?.cityId}
          jurisdictionId={queryParams?.jurisdictionId}
          isLoading={false}
          ref={GridRef}
          onRowClick={onApartmentsGridRowClick}
        />
      </div>
    </Dialog>
  );
}
